module.exports = __webpack_public_path__ + "img/SMS10252-L-min.726ab3eb.png";